"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Ref, Vue } from "vue-property-decorator";
import PaymentNewCouponDialog from "@/views/payItems/components/PaymentNewCouponDialog.vue";
import API from "@ym-framework/api-utils";
import { PaymentController } from "@/service/newProdect";
import _ from "lodash";
let PaymentDiscounts = class extends Vue {
  constructor() {
    super(...arguments);
    this.showMore = false;
    this.paymentCoupons = [];
  }
  mounted() {
  }
  toCost() {
    let router = this.$router.resolve("/cost");
    window.open(router.href, "_blank");
  }
  changeShowMore() {
    this.showMore = !this.showMore;
  }
  isShowCoin() {
    var _a;
    let paymentType = _.find((_a = this._options.selected.categorys) == null ? void 0 : _a.payments, { "payment": this._options.selected.paymentType });
    if (paymentType !== void 0) {
      if (paymentType.useCoin === false) {
        this._options.selected.paymentGoldbeanUsed = 0;
      }
      return paymentType.useCoin;
    } else {
      return true;
    }
  }
  isShowCoupon() {
    var _a;
    let paymentType = _.find((_a = this._options.selected.categorys) == null ? void 0 : _a.payments, { "payment": this._options.selected.paymentType });
    if (paymentType !== void 0) {
      if (paymentType.useCoupon === false) {
        this._options.selected.paymentCoupon = null;
        this._options.selected.paymentDiscountCode = "";
      }
      return paymentType.useCoupon;
    } else {
      return true;
    }
  }
  getCoupons() {
    return __async(this, null, function* () {
      try {
        if (this._payment_style === "renew") {
          let _ids = [];
          for (let item of this._options.selected.virtualDesktopInfo) {
            if (item.oldId) {
              _ids.push(item.oldId);
            } else if (item.config.oldId) {
              _ids.push(item.config.oldId);
            }
          }
          let response = yield API.post(`api://base.auth/api/v7/payment/virtualdesktop/discount_coupon_options/renew`, {
            "goods_spec_guid": this._options.selected.goods.id,
            "pay_type": this._options.selected.paymentType,
            "object_guid_list": _ids
          });
          this.paymentCoupons = response.data.datas;
        }
        if (this._payment_style === "create") {
          let response = yield API.post(`api://base.auth/api/v7/payment/virtualdesktop/discount_coupon_options`, {
            "goods_spec_guid": this._options.selected.goods.id,
            "pay_type": this._options.selected.paymentType,
            "quantity": this._options.selected.paymentQuantity,
            "region_guid": this._options.selected.categorys.id
          });
          this.paymentCoupons = response.data.datas;
        }
        if (this._payment_style === "update" || this._payment_style === "recycle") {
          let response = yield API.post(`api://base.auth/api/v7/payment/virtualdesktop/discount_coupon_options/upgrade`, {
            "goods_spec_guid": this._options.selected.goods.id,
            "pay_type": this._options.selected.paymentType,
            "quantity": this._options.selected.paymentQuantity,
            "region_guid": this._options.selected.categorys.id
          });
          this.paymentCoupons = response.data.datas;
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  discountChange() {
    this.$emit("discountChange");
  }
  payForGoldbean() {
    if (this._options.selected.paymentGoldbeanLimit >= this._options.selected.paymentGoldbeanLeft) {
      this._options.selected.paymentGoldbeanUsed = this._options.selected.paymentGoldbeanLeft;
    } else {
      this._options.selected.paymentGoldbeanUsed = this._options.selected.paymentGoldbeanLimit;
    }
    this.$emit("discountChange");
  }
  openPaymentCoupon() {
    return __async(this, null, function* () {
      yield this.getCoupons();
      this._CouponDialog.open();
    });
  }
};
__decorateClass([
  PropSync("options", {
    default: function() {
      return new PaymentController();
    }
  })
], PaymentDiscounts.prototype, "_options", 2);
__decorateClass([
  PropSync("paymentStyle", {
    default: function() {
      return "create";
    }
  })
], PaymentDiscounts.prototype, "_payment_style", 2);
__decorateClass([
  Ref("coupon-dialog")
], PaymentDiscounts.prototype, "_CouponDialog", 2);
PaymentDiscounts = __decorateClass([
  Component({
    components: {
      PaymentNewCouponDialog
    },
    filters: {
      numFilter: (value) => {
        if (value === "-") {
          return value;
        }
        return Number(value).toFixed(2);
      }
    }
  })
], PaymentDiscounts);
export {
  PaymentDiscounts as default
};
